// Linear categories: convert via a common base unit (factor = value in base
// unit). Temperature isn't linear (different zero points), so it's handled
// separately with real formulas in UnitConverter.js.
export const LINEAR_CATEGORIES = {
  comprimento: {
    label: 'Comprimento',
    units: {
      m: { label: 'Metros (m)', toBase: 1 },
      km: { label: 'Quilômetros (km)', toBase: 1000 },
      cm: { label: 'Centímetros (cm)', toBase: 0.01 },
      mi: { label: 'Milhas (mi)', toBase: 1609.344 },
      ft: { label: 'Pés (ft)', toBase: 0.3048 },
    },
  },
  peso: {
    label: 'Peso',
    units: {
      kg: { label: 'Quilogramas (kg)', toBase: 1 },
      g: { label: 'Gramas (g)', toBase: 0.001 },
      lb: { label: 'Libras (lb)', toBase: 0.453592 },
      oz: { label: 'Onças (oz)', toBase: 0.0283495 },
    },
  },
}

export const TEMPERATURE_UNITS = {
  c: 'Celsius (°C)',
  f: 'Fahrenheit (°F)',
  k: 'Kelvin (K)',
}

export const convertTemperature = (value, from, to) => {
  let celsius
  if (from === 'c') celsius = value
  else if (from === 'f') celsius = ((value - 32) * 5) / 9
  else celsius = value - 273.15

  if (to === 'c') return celsius
  if (to === 'f') return (celsius * 9) / 5 + 32
  return celsius + 273.15
}
